import { useState } from "react";
import { NavLink, Outlet, Link } from "react-router-dom";
import { LayoutGrid, Layers, Menu, X, PanelsTopLeft, Shapes, Columns3, LogOut } from "lucide-react";
import { getUser, logout } from "./api";

const NAV = [
  { to: "/dashboard", label: "Projects", icon: LayoutGrid, testid: "nav-projects" },
  { to: "/materials", label: "Material Catalog", icon: Layers, testid: "nav-materials" },
  { to: "/profiles", label: "Bhoruka Profiles", icon: Shapes, testid: "nav-profiles" },
  { to: "/bway", label: "BWAY Slimpro", icon: Columns3, testid: "nav-bway" },
];

const NavItems = ({ onClick }) => (
  <nav className="flex flex-col gap-1">
    {NAV.map(({ to, label, icon: Icon, testid }) => (
      <NavLink
        key={to}
        to={to}
        onClick={onClick}
        data-testid={testid}
        className={({ isActive }) =>
          `flex items-center gap-3 rounded-md px-3 py-2.5 text-sm transition-colors duration-200 ${
            isActive ? "bg-sky-500/10 text-sky-300 border border-sky-500/30" : "text-zinc-400 hover:text-white hover:bg-zinc-800/60 border border-transparent"
          }`
        }
      >
        <Icon className="h-4 w-4" />
        {label}
      </NavLink>
    ))}
  </nav>
);

const UserBox = () => {
  const u = getUser();
  return (
    <div className="flex items-center justify-between gap-2 rounded-md border border-zinc-800 p-3" data-testid="user-box">
      <div className="min-w-0">
        <div className="truncate text-sm text-zinc-200" data-testid="user-name">{u?.name}</div>
        <div className="truncate font-mono text-[10px] text-zinc-500">{u?.email}</div>
      </div>
      <button data-testid="logout-btn" title="Sign out" onClick={async () => { await logout(); window.location.href = "/"; }} className="rounded-md p-2 text-zinc-400 transition-colors hover:bg-zinc-800 hover:text-white">
        <LogOut className="h-4 w-4" />
      </button>
    </div>
  );
};

const Brand = () => (
  <Link to="/" className="flex items-center gap-2.5" data-testid="brand-link">
    <div className="grid h-9 w-9 place-items-center rounded-md border border-sky-500/40 bg-sky-500/10">
      <PanelsTopLeft className="h-5 w-5 text-sky-400" />
    </div>
    <div>
      <div className="font-[Manrope] text-sm font-extrabold tracking-tight text-white">FACADE STUDIO</div>
      <div className="font-mono text-[10px] uppercase tracking-widest text-zinc-500">Envelope Engineering</div>
    </div>
  </Link>
);

export default function Layout() {
  const [open, setOpen] = useState(false);
  return (
    <div className="min-h-screen bg-[#09090b] text-zinc-100">
      <aside className="fixed inset-y-0 left-0 z-30 hidden w-60 flex-col gap-8 border-r border-zinc-800 bg-[#0c0c0f] p-5 lg:flex">
        <Brand />
        <NavItems />
        <div className="mt-auto"><UserBox /></div>
        <div className="rounded-md border border-zinc-800 p-3 font-mono text-[10px] uppercase tracking-wider text-zinc-500">
          IS 875-3 · IS 16231 · AAMA · CWCT
        </div>
      </aside>
      <header className="sticky top-0 z-30 flex items-center justify-between border-b border-zinc-800 bg-[#0c0c0f]/90 px-4 py-3 backdrop-blur-xl lg:hidden">
        <Brand />
        <button data-testid="mobile-menu-toggle" onClick={() => setOpen(!open)} className="rounded-md border border-zinc-800 p-2">
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </header>
      {open && (
        <div className="border-b border-zinc-800 bg-[#0c0c0f] p-4 lg:hidden" data-testid="mobile-menu">
          <NavItems onClick={() => setOpen(false)} />
          <div className="mt-4"><UserBox /></div>
        </div>
      )}
      <main className="lg:pl-60">
        <div className="mx-auto max-w-[1600px] px-4 py-6 md:px-8 md:py-10">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
